import { DownloadOutlined } from "@ant-design/icons";
import { Button, Flex, Input, message, Spin, Table } from "antd";
import * as XLSX from "xlsx";
import { useGetInventoryQuery } from "../../../api/inventory/inventoryApi";
import redemptionTableColumns from "./RedemptionTableColumns";
import { useGetRedemptionsQuery, useLazyGetRedemptionsQuery } from "../../../api/redemption/redemptionApi";
import { RedemptionGrouped } from "../../../api/redemption/RedemptionGrouped";
import { useEffect, useMemo, useState, useRef } from "react";
import RedemptionDetailsModal from "./RedemptionDetailsModal";
import useQuery from "../../../utils/useQuery";
import { createRedemptionsWorkbook, redemptionsFilename } from "./exportRedemptions";

export default function ManageRedemptionPage() {
  const [messageApi, contextHolder] = message.useMessage();
  const { data, error, isFetching, refetch } = useGetRedemptionsQuery({});
  const [lazyGetRedemptions] = useLazyGetRedemptionsQuery();
  const [selRec, setSelRec] = useState<RedemptionGrouped>();
  const [search, setSearch] = useState<string>("");

  const [redemptionData, setRedemptionData] = useState<RedemptionGrouped[]>();
  const [isFetchingExt, setIsFetchingExt] = useState(false);

  const fetchPgCountRef = useRef(0);

  const query = useQuery();
  const [isPreloaded, setIsPreloaded] = useState(false);

  useEffect(() => {
    // if data changes then update the base data
    async function run() {
      const rd = [];
      let lek = data?.LastEvaluatedKey;
      if (data?.data) {
        rd.push(...data.data);
      }

      while (lek != null) {
      	++(fetchPgCountRef.ref);
        setIsFetchingExt(true);
        console.log("loading more", lek);
        const more = await lazyGetRedemptions({
          lastEvaluatedKey: lek
        }).unwrap();
        if (more?.data) {
          rd.push(...more.data);
        }
        if (more?.LastEvaluatedKey) {
          lek = more.LastEvaluatedKey;
        } else {
          lek = undefined;
          setIsFetchingExt(false);
        }
      }
      setRedemptionData(rd);
      console.log("redemptionData updated:", rd);
      fetchPgCountRef.ref = 0;
    }
    run();
  }, [data, lazyGetRedemptions]);

  const filteredData = useMemo(() => {
    if (!data || !redemptionData) {
      return [];
    }
    const sorted = redemptionData.toSorted((a, b) => -a.orderDate.localeCompare(b.orderDate));
    return sorted.filter(item => {
      // console.log("item:", item);
      const j = JSON.stringify(item);
      return j.toLowerCase().includes(search.toLowerCase());
      // return Object.values(item).some(value => {
      //   if (typeof value === "string") {
      //     return value.toLowerCase().includes(search.toLowerCase());
      //   }
      //   if (typeof value === "number") {
      //     return value.toString().includes(search);
      //   }
      //   return false;
      // });
    });
  }, [redemptionData, search]);

  useEffect(() => {
    if (isFetching)
      messageApi.loading("Loading data...");
    else
      messageApi.destroy();
  }, [isFetching, messageApi]);


  useEffect(() => {
    if (isPreloaded || isFetching || isFetchingExt || error || !messageApi || !redemptionData) {
      return;
    }

    const refer = query.get("reference");
    if (refer == null) {
      return;
    }

    const oid = refer.split(",")[0];
    const rec = redemptionData.find(x => x.orderId === oid);

    if (rec == null) {
      messageApi.error("Failed to load redemption data");
      return;
    }

    setSelRec(rec);

    setIsPreloaded(true);
  }, [isPreloaded, query, isFetching, error, redemptionData, isFetchingExt, messageApi]);

  function handleViewDetails(rg: RedemptionGrouped) {
    setSelRec(rg);
  }

  function handleDownload() {
    try {
      const redemptions = filteredData.flatMap(({ kycs }) => kycs);
      if (redemptions.length === 0) {
        messageApi.warning("No redemption orders to export");
        return;
      }

      const workbook = createRedemptionsWorkbook(redemptions);
      XLSX.writeFile(workbook, redemptionsFilename());
      messageApi.success(`Exported ${redemptions.length} redemption records successfully`);
    } catch (downloadError) {
      console.error("Redemption orders export error:", downloadError);
      messageApi.error("Failed to export redemption orders. Please try again.");
    }
  }

  console.log("filteredData:", filteredData);

  console.log(data, error, isFetching);
  return (
    <Flex gap={8} vertical>
    {contextHolder}
    <Flex gap={8}>
      <Input.Search
        placeholder="Search columns"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ flex: 1 }}
      />
      <Button
        icon={<DownloadOutlined />}
        loading={isFetching || isFetchingExt}
        disabled={filteredData.length === 0}
        onClick={handleDownload}
      >
        Download
      </Button>
    </Flex>

    { (fetchPgCountRef.ref > 0) && <>
      Loading page... ({fetchPgCountRef.ref})
    </> }
    <Table
      columns={redemptionTableColumns(handleViewDetails)}
      dataSource={filteredData}
      loading={{
        indicator: (
          <div>
            <Spin />
          </div>
        ),
        spinning: isFetching || isFetchingExt,
      }}
      pagination={{
        defaultPageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
        defaultCurrent: 1
      }}
      size="small"
      bordered
      showHeader
    />


    <RedemptionDetailsModal
      isModalVisible={selRec != null}
      setIsModalVisible={v => setSelRec(v ? selRec : undefined)}
      data={selRec ?? null}
      onRefetch={refetch}
    />
    </Flex>
  );
}
